const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-3 border-noe-800 border-t-noe-brand rounded-full animate-spin"></div>
        <div className="text-noe-500 text-sm">Carregando...</div>
      </div>
    </div>
  )
}

export default LoadingSpinner